<template>
  <ValidationObserver ref="addressForm">
    <form>
      <div>
        <BaseLabel
          text="Postcode"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
          }"
          actionBtnLabel="Use address finder"
          @click:actionBtn="openInputFindProperty()"
        />
        <BaseInput
          ref="postCode"
          :vid="vid?.postCode"
          fieldName="postCode"
          :value="addressForm.postCode.Value"
          :dataUiid="DATA_UIID.insuredAddressPostCode"
          :rules="{
            required: {
              fieldLabel: LABEL_CONSTANTS.POST_CODE_LABEL_MSG,
            },
            regex: {
              pattern: POST_CODE_PATTERN,
              customMessage: ERROR_MSG_CONSTANTS.ERROR_MSG_POSTCODE,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          @blur="handleBlur"
          aria-label="Postcode"
        />

        <BaseLabel :text="LABEL_CONSTANTS.STREET"></BaseLabel>
        <BaseInput
          :vid="vid?.street"
          fieldName="street"
          :dataUiid="DATA_UIID.insuredAddressStreet"
          :value="addressForm.street.Value"
          :rules="{
            required: {
              fieldLabel: LABEL_CONSTANTS.STREET_LABEL_MSG,
            },
            regex: {
              pattern: ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
              customMessage:
                ERROR_MSG_CONSTANTS.ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER,
            },
            maxLength: {
              fieldLabel: LABEL_CONSTANTS.STREET_LABEL_MSG,
              length: 30,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          @blur="handleBlur"
          aria-label="Street"
        />

        <BaseLabel :text="LABEL_CONSTANTS.DISTRICT"></BaseLabel>
        <BaseInput
          :vid="vid?.district"
          fieldName="district"
          :dataUiid="DATA_UIID.insuredAddressDistrict"
          :value="addressForm.district.Value"
          :rules="{
            regex: {
              pattern: ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
              customMessage:
                ERROR_MSG_CONSTANTS.ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER,
            },
            maxLength: {
              fieldLabel: LABEL_CONSTANTS.DISTRICT_LABEL_MSG,
              length: 30,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          @blur="handleBlur"
          aria-label="District"
        />

        <BaseLabel :text="LABEL_CONSTANTS.TOWN"></BaseLabel>
        <BaseInput
          :vid="vid?.town"
          fieldName="town"
          :dataUiid="DATA_UIID.insuredAddressTown"
          :value="addressForm.town.Value"
          :rules="{
            required: {
              fieldLabel: LABEL_CONSTANTS.TOWN_LABEL_MSG,
            },
            regex: {
              pattern: ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
              customMessage:
                ERROR_MSG_CONSTANTS.ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER,
            },
            maxLength: {
              fieldLabel: LABEL_CONSTANTS.TOWN_LABEL_MSG,
              length: 30,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          @blur="handleBlur"
          aria-label="Town"
        />

        <BaseLabel :text="LABEL_CONSTANTS.COUNTY"></BaseLabel>
        <BaseInput
          :vid="vid?.county"
          fieldName="county"
          :dataUiid="DATA_UIID.insuredAddressCounty"
          :value="addressForm.county.Value"
          :rules="{
            regex: {
              pattern: ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
              customMessage:
                ERROR_MSG_CONSTANTS.ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER,
            },
            maxLength: {
              fieldLabel: LABEL_CONSTANTS.COUNTY_LABEL_MSG,
              length: 30,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          @blur="handleBlur"
          aria-label="County"
        />
      </div>

      <slot name="saveButton" />
    </form>
  </ValidationObserver>
</template>

<script>
import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
import { ADDRESS_FINDER_ANSWER_MAP as DATA_UIID } from "@/constants/form.constants";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import * as ERROR_MSG_CONSTANTS from "@/constants/message.constants";
import {
  ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
  POST_CODE as POST_CODE_PATTERN,
} from "@/constants/regex-patterns.constants";
import { ValidationObserver } from "vee-validate";
export default {
  name: "AddressManualForm",
  props: {
    addressForm: {
      type: Object,
      required: true,
    },
    vid: {
      type: Object,
      required: false,
    },
  },
  components: {
    BaseInput,
    ValidationObserver,
    BaseLabel,
  },
  data() {
    return {
      POST_CODE_PATTERN,
      ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
      LABEL_CONSTANTS,
      ERROR_MSG_CONSTANTS,
      DATA_UIID,
    };
  },
  mounted() {
    this.$refs.postCode.$el.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
  },
  methods: {
    openInputFindProperty() {
      this.$emit("openInputFindProperty");
    },
    async handleBlur(value, fieldName, provider) {
      if (!fieldName || !this.addressForm[fieldName] || !provider) {
        console.warn(
          "Missing data for either fieldname, provider, or fieldname does not exist in addressForm, see detailed log below"
        );
        console.warn("fieldName:", fieldName);
        console.warn("addressForm:", this.addressForm[fieldName]);
        console.warn("provider:", provider);
        return;
      }
      const valid = (await provider.validate()).valid;
      if (valid) {
        this.addressForm[fieldName].Value = value;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
